<template>
  <div class="head-tip">
    <div class="head-tip-content flex">
      <WFormCreator ref="searchForm" :options.sync="options">
        <template #something>
          <el-button type="primary" @click="fnSearch">查询
          </el-button>
          <!-- <el-button type="caicai" plain>批量导出
          </el-button> -->
          <el-button @click="resetForm">重置</el-button>
        </template>
      </WFormCreator>
    </div>
  </div>
</template>

<script>
import {getSubmitter} from "@/api/vgmBase";
import moment from 'moment'

export default {
  name: "Header",
  props: {},
  data() {
    return {
      options: {

        formAttrs: {
          rules: {},

        },
        formItemAttrs: {
          billNo: {type: 'input', label: '提单号', placeholder: '请输入提单号', width: '320px'},
          containerNo: {type: 'input', label: '箱号', placeholder: '请输入箱号', width: '180px'},
          userRemark: {type: 'input', label: '客户备注', placeholder: '请输入客户备注', width: '320px'},
          userId: {
            type: 'select',
            label: '提交人',
            selectOpts: [],
            placeholder: '请选择提交人'
          },
          sendTime: {type: 'daterange', label: '发送日期', width: '320px'},
          something: {
            label: '',
            slot: 'something'
          }
        }
      }
    }
  },
  created() {
    if(this.$route.path=='/vgm/draft'){
      delete this.options.formItemAttrs.sendTime
    }
  },
  mounted() {
    this.getSubmitter()
  },
  methods: {
    //获取提交人
    getSubmitter() {
      getSubmitter().then(async res => {
        let arr = []
        res.data?.forEach((item) => {
          let obj = {
            value: item.userId,
            label: item.nickName
          }
          arr.push(obj)
        })
        this.options.formItemAttrs.userId.selectOpts = arr
        if(this.$route.path!='/vgm/draft'){
          let nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), '23', '59', '59')

          await this.$refs.searchForm.setFormData({
            sendTime: [moment(nowDate.getTime() - 3600 * 1000 * 24 * 31 + 1000).format('YYYY-MM-DD HH:mm:ss'), moment(nowDate.getTime()).format('YYYY-MM-DD HH:mm:ss')]
          })
        }

        this.fnSearch()
      })
    },
    // 用户点击查询/订阅
    fnSearch() {
      let query = this.$refs['searchForm'].getFormData()
      this.$refs['searchForm'].$refs['refForm'].validate((bool) => {
        if (bool) this.$emit('search', query)
      })
    },

    // 重置
    resetForm() {
      this.$refs['searchForm'].resetForm()
    },
    // 设置初始值
    setFormData(val) {
      this.$refs['searchForm'].setFormData(val)
    }
  }
};
</script>
<style scoped lang="less">
.head-tip {
  border-radius: 4px;

  .head-tip-content {
    padding-left: 24px;
    font-size: 14px;
  }
}
</style>